import { render, staticRenderFns } from "./SACToggleSwitch.vue?vue&type=template&id=412c8443"
import script from "./SACToggleSwitch.vue?vue&type=script&lang=js"
export * from "./SACToggleSwitch.vue?vue&type=script&lang=js"
import style0 from "./SACToggleSwitch.vue?vue&type=style&index=0&id=412c8443&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports